import { createContext, useContext } from 'react';

import type { Softphone } from '../telephony/useSoftphone';

/**
 * The telephone, mounted once for the life of the console.
 *
 * `useSoftphone` registers with the PBX, holds the JsSIP user agent and owns the one
 * `<audio>` element the far end comes out of. Called from a view, all three would be torn
 * down and rebuilt every time somebody pressed `2` — which is a dropped call for switching
 * screens. So it is called once, in the shell, above the routes.
 */
export const SoftphoneContext = createContext<Softphone | null>(null);

export function usePhone(): Softphone {
  const phone = useContext(SoftphoneContext);

  if (phone === null) {
    throw new Error('The telephone was used outside the console shell.');
  }

  return phone;
}
